/**
 * Service for area update operations
 */

import { apiClient } from '@/api/core/apiClient';
import { API_CONFIG } from '@/api/core/apiConfig';
import type { ApiResponse } from '@/api/shared/types';
import {
  mapUpdateAreaFromTransport,
  mapUpdateAreaToTransport,
} from '../mappers';
import type {
  UpdateAreaRequest,
  UpdateAreaResult,
  LC_UpdateCompanyAreaOut,
} from '../types';


export class AreaUpdateService {
  /**
   * Update an existing area
   *
   * Response codes:
   * - 200: Area updated successfully
   * - 400: Validation error (VALIDATION_ERROR)
   * - 404: Area not found (NOT_FOUND)
   * - 409: Conflict - duplicate area code (CONFLICT)
   * - 500: Internal server error
   */
  async update(
    areaId: number,
    request: UpdateAreaRequest,
  ): Promise<ApiResponse<UpdateAreaResult>> {
    const endpoint = API_CONFIG.ENDPOINTS.ORGANIZATION.AREA_BY_ID(areaId);
    const payload = mapUpdateAreaToTransport(request);

    const response = await apiClient.put<LC_UpdateCompanyAreaOut>(
      endpoint,
      payload,
      
    );

    if (response.success && response.data) {
      return {
        ...response,
        data: mapUpdateAreaFromTransport(response.data),
      };
    }

    return { ...response, data: null };
  }
}

export const areaUpdate = new AreaUpdateService();
